import hyRequest from '@/service'
import { IDataType } from '@/service/types'

// 查询角色列表
export function listRole(query: any) {
  return hyRequest.get<IDataType>({
    url: '/system/role/list',
    params: query
  })
}

// 查询角色详细
export function getRole(roleId: string | number) {
  return hyRequest.get<IDataType>({
    url: '/system/role/' + roleId
  })
}

// 新增角色
export function addRole(data: any) {
  return hyRequest.post<IDataType>({
    url: '/system/role',
    data
  })
}

// 修改角色
export function updateRole(data: any) {
  return hyRequest.put<IDataType>({
    url: '/system/role',
    data
  })
}

// 角色数据权限
export function dataScope(data: any) {
  return hyRequest.put<IDataType>({
    url: '/system/role/dataScope',
    data
  })
}

// 角色状态修改
export function changeRoleStatus(roleId: string | number, status: string | number) {
  const data = {
    roleId,
    status
  }
  return hyRequest.put<IDataType>({
    url: '/system/role/changeStatus',
    data
  })
}

// 删除角色
export function delRole(roleId: string | number) {
  return hyRequest.delete<IDataType>({
    url: '/system/role/' + roleId
  })
}

// 查询角色已授权用户列表
export function allocatedUserList(query: any) {
  return hyRequest.get<IDataType>({
    url: '/system/role/authUser/allocatedList',
    params: query
  })
}

// 查询角色未授权用户列表
export function unallocatedUserList(query: any) {
  return hyRequest.get<IDataType>({
    url: '/system/role/authUser/unallocatedList',
    params: query
  })
}

// 取消用户授权角色
export function authUserCancel(data: any) {
  return hyRequest.put<IDataType>({
    url: '/system/role/authUser/cancel',
    data
  })
}

// 批量取消用户授权角色
export function authUserCancelAll(data: any) {
  return hyRequest.put<IDataType>({
    url: '/system/role/authUser/cancelAll',
    params: data
  })
}

// 授权用户选择
export function authUserSelectAll(data: any) {
  return hyRequest.put<IDataType>({
    url: '/system/role/authUser/selectAll',
    params: data
  })
}

// 根据角色ID查询部门树结构
export function deptTreeSelect(roleId: string | number) {
  return hyRequest.get<IDataType>({
    url: '/system/role/deptTree/' + roleId
  })
} 